import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Cta from "@components/CTA";
import IconGoTop from "@images/icons/scroll-top-icon.png";
import { focusLoop } from "@utils/helper";

const showCookiePreferenceCenter = () => {
	if ('OneTrust' in window) {
		window.OneTrust.ToggleInfoDisplay();
	}
	document.addEventListener('keydown', (e) => focusLoop(e, '#onetrust-consent-sdk #ot-pc-content a, #onetrust-consent-sdk #ot-pc-content button, #onetrust-consent-sdk #ot-pc-content input, #onetrust-consent-sdk .ot-pc-header button, #onetrust-consent-sdk .ot-pc-footer button'));

	document.querySelector('#onetrust-consent-sdk .ot-pc-header button')?.addEventListener('click', () => {
		document.removeEventListener('keydown', focusLoop);
	})
}

const Footer = ({ nav }) => {
	const data = useStaticQuery(graphql`
		query FooterQuery {
			contentfulContainer(contentful_id: {eq: "7eqsF9VauPTOlHL6Fp9C7U"}) {
				entryTitle
				items {
					... on ContentfulContainer {
						...ContentfulContainerFragment
					}
					... on ContentfulMedia {
						...ContentfulMediaFragment
					}
				}
			}
		}
	`);

	const goTop = () => {
		const scrollToTop = () => {
			const currentPosition = window.pageYOffset;
			if (currentPosition > 0) {
				// Slower smooth scrolling with a smaller step size
				window.scrollTo(0, currentPosition - currentPosition / 15);
				window.setTimeout(scrollToTop, 20);
			}
		};
		scrollToTop();
	};

	const footer = data.contentfulContainer || [];

	return (
		<footer className="w-full bg-dark_green rounded-top_48">
			<div className="container-default mx-auto px-[0] xl:px-0 lg:max-w-lg xl:max-w-default ">
				{footer.items?.length ? (
					<>
						<div className="flex flex-col-reverse items-center justify-between gap-4 pt-8 pb-8 font-bold lg:flex-col lg:text-center  xl:flex-row">
							<div className="logo-container">
								{footer.items[0]?.asset?.file?.url && (
									<Cta
										displayType="Link"
										href="https://www.pacira.com/"
										label={<img src={footer.items[0].asset.file.url} alt={footer.items[0].altText || "Logo"} />}
										style={`inline-block h-auto max-w-[180px] w-full`}
									/>
								)}
							</div>
							<ul className="flex !flex-row gap-2 mb-6 md:flex border-t border-separator  border-b  lg:hidden">
								{footer.items[2]?.items[1]?.items?.map((linkItem, index) =>
									(linkItem?.__typename === "ContentfulLink") ? (
										<li
											key={index}
											className={`py-[40px] items-center pr-[4px] pl-[4px] text-center lg:border-l border-separator border-l-0 [&:first-child]:border-l-0`}
										>
											<Cta
												label={linkItem?.label}
												href={linkItem?.href || '#'}
												className={``}
												style={`block h-6 w-6 w-6 h-6 inline-block`}
												displayType={linkItem?.displayType}
											/>
										</li>
									) : null
								)}
							</ul>
							<ul className="block flex-wrap flex-col gap-6 md:flex lg:flex-nowrap items-center lg:gap-0 justify-center lg:justify-end py-4 md:(flex-col) lg:flex-row">
								{footer.items[1]?.items?.map((link, index) => (
									<li
										key={index}
										className={`py-[10px] md:py-0 items-center pr-[16px] pl-[16px] text-center lg:border-l border-separator  [&:first-child]:border-l-0`}
									>
										{link?.contentfulid === "cookie-settings" ? (
											<button onClick={showCookiePreferenceCenter} className={"text-white p_bold hover:opacity-80"}>
												{link?.label}
											</button>
										) : (
											<Cta
												label={link?.label}
												href={link?.href || '#'}
												className=""
													style={`text-white p_bold hover:opacity-80`}
												displayType={link?.displayType}
											/>
										)}
									</li>
								))}
							</ul>
							<button className="lg:hidden" onClick={goTop}>
								<img src={IconGoTop} alt="References" className="w-[56px] h-[56px]" />
							</button>
						</div>
						<div className="flex flex-row items-center lg:justify-between justify-center pb-12">
							<div className="copyright text-white text-p_medium capitalize !font-[400] text-center md:text-center xl:text-left px-[10px] md:px-0">
								{footer.items[2]?.items?.[0]?.text?.raw &&
									documentToReactComponents(JSON.parse(footer.items[2].items[0].text.raw))
								}
							</div>
							<div className="hidden lg:flex">
								<ul className="flex !flex-row gap-2 md:flex">
									{footer.items[2]?.items[1]?.items?.map((linkItem, index) =>
										(linkItem?.__typename === "ContentfulLink") ? (
											<li
												key={index}
												className={` py-[40px] md:py-0 items-center pr-[4px] pl-[4px] text-center `}
											>
												<Cta
													label={linkItem?.label}
													href={linkItem?.href || '#'}
													className={``}
													style={`w-6 h-6 inline-block`}
													displayType={linkItem?.displayType}
												/>
											</li>
										) : null
									)}
								</ul>
							</div>
						</div>
					</>
				) : null}
			</div>
		</footer>
	);
};

export default Footer;
